import {ILoraForwarderBasicStationService} from '@/services/lora/forwarder/BasicStation/ILoraForwarderBasicStation.service';

import {injectable} from 'inversify-props';

import {LoraForwarderStdService} from '@/services/lora/forwarder/LoraForwarderStd.service';
import {LoraForwarderBasicStationServerConfigService} from '@/services/lora/forwarder/BasicStation/LoraForwarderBasicStationServerConfig.service';

@injectable()
export class LoraForwarderBasicStationService extends LoraForwarderStdService implements ILoraForwarderBasicStationService {

  public CupsBootConfig: LoraForwarderBasicStationServerConfigService;
  public CupsConfig: LoraForwarderBasicStationServerConfigService;

  public LnsBootConfig: LoraForwarderBasicStationServerConfigService;
  public LnsConfig: LoraForwarderBasicStationServerConfigService;

  constructor() {
    super('/lora/forwarder/lora-basic-station');

    this.CupsBootConfig = new LoraForwarderBasicStationServerConfigService(`${this.path}/cups-boot`);
    this.CupsConfig = new LoraForwarderBasicStationServerConfigService(`${this.path}/cups`);

    this.LnsBootConfig = new LoraForwarderBasicStationServerConfigService(`${this.path}/lns-boot`);
    this.LnsConfig = new LoraForwarderBasicStationServerConfigService(`${this.path}/lns`);

  }
}
